<template>
  <div
    class="action-block"
    :class="{ 'action-block--plain': plain, 'action-block--rewards': rewards }"
  >
    <img
      v-if="iconSrc"
      :src="iconSrc"
      class="action-block__icon-img"
      alt=""
      :width="rewards ? 48 : 32"
      :height="rewards ? 48 : 32"
    />
    <i v-else :class="['icon', `icon-${icon}`]"></i>
    <h3 class="action-block__title">{{ title }}</h3>
    <p class="action-block__description">{{ description }}</p>
    <Button
      v-if="action"
      size="medium"
      :href="action.href"
      :tag="action.tag"
      :disabled="action.disabled"
      @click="action.onClick"
    >
      {{ action.text }}
    </Button>
  </div>
</template>

<script>
import Button from "@/components/ButtonV3.vue";

export default {
  name: "ActionBlock",
  components: {
    Button,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: "bag",
    },
    action: {
      type: Object,
      default: null,
    },
    plain: {
      type: Boolean,
      default: false,
    },
    rewards: {
      type: Boolean,
      default: false,
    },
    iconSrc: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.action-block {
  background-color: #f8f8f8;
  padding: 20px;
  text-align: center;
  border-radius: 8px;
  @include editorial-headline(14px);
  line-height: 150%;
  padding-top: 28px;
  padding-bottom: 28px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &--plain {
    background-color: transparent !important;
    border: none;
    box-shadow: none;
    border-radius: 0;
    padding: 0;

    .action-block__description {
      margin-bottom: 0;
    }
  }

  &__title {
    margin-top: 12px;
    margin-bottom: 8px;
    text-transform: uppercase;
  }

  &__description {
    @include editorial-body(14px);
    line-height: 150%;
    margin-bottom: 20px;
  }
}

.icon {
  font-size: 24px;
}

.action-block__icon-img {
  width: 32px;
  height: 32px;
  object-fit: contain;
  display: block;
  flex-shrink: 0;
}

.action-block--rewards {
  gap: 0;
  padding: 28px 20px 48px;
  border-radius: 4px;

  .action-block__icon-img {
    width: 48px;
    height: 48px;
    margin-bottom: 20px;
  }

  h3.action-block__title {
    margin: 0 0 8px;
    font-family: $editorial-font-family;
    font-weight: 300;
    font-style: normal;
    font-size: 14px;
    line-height: 150%;
    text-align: center;
    text-transform: uppercase;
    color: #000;
  }

  p.action-block__description {
    margin: 0;
    font-family: $utility-font-family;
    font-weight: 400;
    font-style: normal;
    font-size: 14px;
    line-height: 150%;
    text-align: center;
    color: #000;
  }
}

.action-block--plain .action-block__title {
  margin-top: 16px;
}

.action-block--plain .action-block__icon-img {
  width: 36px;
  height: 36px;
}
</style>
